module.exports = __webpack_public_path__ + "components/country-flag/static/fj-58d3e29f4ee72130ece4b5b4ed24f70b.svg";